/**
 * Labstep
 *
 * @module components/PurchaseOrder/Status
 * @desc PurchaseOrder Request status + option to change
 */

import type React from 'react';
import styles from './styles.module.scss';
import type { IPurchaseOrderStatusActionProps } from './types';

export const PurchaseOrderStatus: React.FC<
  IPurchaseOrderStatusActionProps
> = ({ purchaseOrder }) => (
  <span className={styles[purchaseOrder.status]}>
    {purchaseOrder.printStatus}
  </span>
);
